import { useQuery, UseQueryResult } from "@tanstack/react-query"
import { ProviderFinderNetworkCustomization } from "#/lib/carrot-api/types/ProviderFinderNetworkCustomization"
import { carrotClient } from "#/utils/CarrotClient"

export const useGetProviderFinderNetworkCustomization = (): UseQueryResult<ProviderFinderNetworkCustomization> => {
  return useQuery<ProviderFinderNetworkCustomization>(
    ["providerFinderNetworkCustomization"],
    () => carrotClient.getProviderFinderNetworkCustomization(),
    {
      staleTime: 10 * 60 * 1000, // 10 minutes - data is considered fresh for this duration
      cacheTime: 15 * 60 * 1000 // 15 minutes - cache persists for this duration after becoming inactive
    }
  )
}
